// extracted by mini-css-extract-plugin
export default {"modal":"ErrorPopup_modal__8SmLO","popUp":"ErrorPopup_popUp__3pTfv","header":"ErrorPopup_header__F-aem","text":"ErrorPopup_text__1zUqm","icon":"ErrorPopup_icon__2VnVr"};
    if(module.hot) {
      // 1741870133732
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  